export default __webpack_public_path__ + "static/media/0012.2d6f62db.jpg";